import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCustomerAddress } from '../../api/apiStorefront';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useCreateCustomerAddress = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (addressData) => {
      const response = await createCustomerAddress(addressData);
      return response.data;
    },
    onSuccess: () => {
      toast.success(t('address.created', 'Address created successfully!'));
      queryClient.invalidateQueries(['customer-addresses']);
    },
    onError: (error) => {
      const message = error.response?.data?.message || t('address.createError', 'Failed to create address');
      toast.error(message);
    },
  });
};
